import React, { useState, useEffect, useMemo } from "react";
import { getOr } from "lodash/fp";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { buildUrlFromTableParams } from "../../../../lib/functions/common";
import { mainStateKey, defaultListingTableRowNumber } from "../../../../constants/constants";
import labelDataManipulation from "../../../../lib/dataManipulation/label/labelDataManipulation";
import FiltersBox from "./filtersBox";
import {
  setTableData,
  resetPageOnFilterChange,
  getColumnDefinitions,
  setEditButtonCustomRender,
} from "../../../../lib/functions/tableFunctions";
import { editLabelTableParametersData } from "../../../../constants/tableParametersData/editLabelTableParametersData";
import { usePrevious, useResetPageState } from "../../../../lib/functions/customHooks";
import { SET_STATE_VALUE } from "../../../../redux/reducers/common/actionTypes";
import { dispatchToReduxStore } from "../../../../lib/functions/componentFunctions";
import { useHistory } from "react-router";
import ListingTable from "../../../presentational/table/listingTable";

const EditLabelListPage = ({ filters, sortData, row, page, dispatch }) => {
  useResetPageState();

  const routerHistory = useHistory();
  const statePath = editLabelTableParametersData.statePath;
  const sortPath = editLabelTableParametersData.sortPath;
  const filtersPath = editLabelTableParametersData.filtersPath;
  const allColumns = editLabelTableParametersData.columns;
  const previousFilters = usePrevious(filters);
  const [tableRowData, setTableRowData] = useState([]);
  const [tablePaginationData, setTablePaginationData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTableData(
      setTableRowData,
      setTablePaginationData,
      setLoading,
      buildUrlFromTableParams(filters, sortData, editLabelTableParametersData, row, page),
      labelDataManipulation,
      "label"
    );
  }, [filters, sortData, row, page, dispatch]);

  resetPageOnFilterChange(previousFilters, filters, statePath, dispatch);
  let columns = useMemo(
    () => setColumnDefinitions(allColumns, sortPath, dispatch, statePath, routerHistory, tableRowData),
    [allColumns, dispatch, routerHistory, sortPath, statePath, tableRowData]
  );

  return (
    <React.Fragment>
      <section className="content-header">
        <h1>
          Edit label &nbsp;
          <button
            className="btn btn-default btn-small"
            onClick={() => {
              dispatchToReduxStore(filtersPath, SET_STATE_VALUE, null, dispatch);
            }}
          >
            Clear filters
          </button>
        </h1>
      </section>
      <section className="content">
        <FiltersBox />
        <div className={loading ? "loading" : ""}>
          <div className="row">
            <div className="col-md-12">
              <ListingTable
                statePath={statePath}
                sortPath={sortPath}
                tablePaginationData={tablePaginationData}
                columnDefinitions={columns}
                tableRowData={tableRowData}
                columnsConstant={allColumns}
              />
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

const setColumnDefinitions = (allColumns, sortPath, dispatch, statePath, routerHistory) => {
  const columns = getColumnDefinitions(allColumns, sortPath);
  setEditButtonCustomRender(columns, dispatch, statePath, routerHistory, "/edit/label/");
  return columns;
};

EditLabelListPage.propTypes = {
  filters: PropTypes.object,
  row: PropTypes.number,
  page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sortData: PropTypes.object,
  dispatch: PropTypes.func,
};

const mapStateToProps = state => {
  return {
    filters: getOr(null, `${mainStateKey}.${editLabelTableParametersData.filtersPath}`, state),
    sortData: getOr(null, `${mainStateKey}.${editLabelTableParametersData.sortPath}`, state),
    row: getOr(defaultListingTableRowNumber, `${mainStateKey}.${editLabelTableParametersData.statePath}.rows`, state),
    page: getOr(0, `${mainStateKey}.${editLabelTableParametersData.statePath}.page`, state),
  };
};

export default connect(mapStateToProps)(EditLabelListPage);
